<template>
  <v-row>
    <v-col
      class="d-flex align-center justify-start mb-2"
      cols="12"
      sm="9"
    >
      <h1
        ref="title"
        class="focus-invisible fs-36 fw-600 me-4"
        tabindex="0"
      >
        {{ $bct('Hi') }}, {{ firstName }}!
      </h1>
    </v-col>

    <v-col
      v-if="!hubExperience"
      class="d-flex justify-end"
      cols="12"
      sm="3"
    >
      <v-btn
        v-if="addChild && !v2"
        @click="emit('add-child')"
        class="focus-very-visible"
        color="primary"
        data-cy="add-child-button"
        prepend-icon="add"
        size="large"
        rounded
      >
        {{ $bct('Add child') }}
      </v-btn>
      <v-btn
        v-if="addChild && v2 && !disableNewApplication"
        @click="emit('add-application')"
        class="focus-very-visible"
        color="primary"
        prepend-icon="add"
        size="x-large"
        rounded
      >
        {{ $bct('New application') }}
      </v-btn>
    </v-col>
  </v-row>
</template>

<script setup>
import { useStore } from 'vuex';

defineProps({
  addChild: {
    type: Boolean,
    default: false,
  },
  disableNewApplication: {
    type: Boolean,
    default: false,
  },
  firstName: {
    type: String,
    default: null,
  },
  hubExperience: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['add-application', 'add-child']);

const store = useStore();
const $bct = inject('translator');

const v2 = computed(() => store.state.config.enable_parent_dashboard_v2);
</script>
